import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Dropdown, Form, Button, Spinner } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import $ from "jquery";
import { Utils } from "../../../../../../Common/Utilis"
import _ from "lodash";
import moment from "moment";
import { resolve, reject } from "q";
import { DailyActivityService as TaxAuditService } from "../../../../../../Common/Services/DailyActivity";
import { toast } from "react-toastify";

const isData: any = [
    {
        id: 0,
        explanation: "Tax Exempt Expedia",
        category: "Exempt: OTA",
        exemptRevenue: "-15504.25",
        exemptTax: "-6666.25",

        isEdit: false,
        errExp: false,
        errCate: false,
        errRev: false,
        errTax: false
    },
]

export class TaxCategoty extends React.Component<any, any> {
    private readonly categoryScroll: any;
    constructor(props: any) {
        super(props);
        this.categoryScroll = React.createRef();
        this.state = {
            hotelName: "",
            tableData: [],
            categoryList: [
                { id: 1, value: "Exempt: Federal Govt" },
                { id: 2, value: "Exempt: State Govt" },
                { id: 3, value: "Exempt: Long Term Stay" },
                { id: 6, value: "Exempt: OTA" },
                { id: 5, value: "Addl Tax: Online Traval Company" },
                { id: 4, value: "Other" },
                { id: 7, value: "Reward Reimbursement" },
            ],
            isDataLoading: false,
        };
    }


    componentDidMount(): void {
        this.GetTaxAuditDetails();
    }

    GetTaxAuditDetails = async () => {
        let { filterHotelId, selectedDate, auditid } = this.props?.selectedRow;
        this.setState({ isDataLoading: true });
        TaxAuditService.GetTaxAuditDetails(filterHotelId, selectedDate, auditid)
            .then(async (result: any | null) => {
                debugger;
                if (result !== null && result.length > 0) {
                    result = result.map((o: any) => {
                        o.totalRevenue2 = o.totalRevenue;
                        o.totalActualTax2 = o.totalActualTax;
                        o.totalRevenueTax2 = o.totalRevenueTax;
                        o.exemptRevenue2 = o.exemptRevenue;
                        o.isEdit = false;
                        o.errExp = false;
                        o.errCate = false;
                        o.errRev = false;
                        o.errTax = false;
                        return o
                    })
                    this.setState({ tableData: result, defTableData: result, isDataLoading: false });
                } else {
                    this.setState({ tableData: [], defTableData: [], isDataLoading: false });
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ tableData: [], isDataLoading: false });
                Utils.toastError(error?.message, { position: toast.POSITION.BOTTOM_RIGHT });
                reject();
            });
    };

    hideTaxCategoty = () => {
        this.props?.close();
    }

    handleInputChange = (e: any, rowIndex: any, row: any, type: any) => {
        let { tableData } = this.state;
        let { value } = (type === "category" ? JSON.parse(e) : e.target);
        let cursorIndex = (type !== "category" && e.target.selectionStart);
        let index = tableData.findIndex((x: any) => x.rNo === row.rNo);
        if (type === "explanation" && index >= 0) {
            let inputId = "explanation_" + rowIndex;
            tableData[index].explanation = value;
            tableData[index].errExp = (tableData[index].explanation === "");
            this.setState({ tableData }, () => {
                $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
            });
        } else if (type === "category" && index >= 0) {
            tableData[index]['category'] = value;
            tableData[index].errCate = (tableData[index].category === "");
            this.setState({ tableData });
        } else if (type === "exemptRevenue" && index >= 0) {
            let inputId = "exemptRevenue_" + rowIndex;
            let validAmount = this.handleValidAmount(value);
            tableData[index]['exemptRevenue'] = validAmount;
            tableData[index].errRev = (validAmount.length === 0)
            this.setState({ tableData }, () => {
                $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
            });
        } else if (type === "exemptTax" && index >= 0) {
            let inputId = "exemptTax_" + rowIndex;
            let validAmount = this.handleValidAmount(value);
            tableData[index]['exemptTax'] = validAmount;
            tableData[index].errTax = (validAmount.length === 0)
            this.setState({ tableData }, () => {
                $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
            });
        }
    }

    handleValidAmount = (orderAmount) => {
        let newVal = Utils.removeInvaildCharFromAmount(orderAmount);
        orderAmount = newVal;
        const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        let lenbeforePoint = 8;
        if (orderAmount.includes("-")) {
            lenbeforePoint = 9;
        }
        let validAmount: any;
        if (rx_live.test(orderAmount)) {
            if (orderAmount.includes(".")) {
                const timeArray = (orderAmount)?.split(".");
                if (timeArray[0].length <= lenbeforePoint && timeArray[1].length <= 2) {
                    validAmount = orderAmount;
                }
            } else {
                if (orderAmount.length <= lenbeforePoint) {
                    validAmount = orderAmount;
                }
            }
        } else if (orderAmount.includes(".") && orderAmount.length === 1) {
            validAmount = orderAmount;
        }
        return validAmount
    }

    isValidOnBlurAmount = (e) => {
        let afterBlurAmount: any;
        let newval = Utils.removecurrencyFormat(e.target.value);
        e.target.value = newval;
        if (!isNaN(e.target.value)) {
            if (e.target.value.includes(".")) {
                const timeArray = (e.target.value)?.split(".");
                if (timeArray[1].length <= 0) {
                    afterBlurAmount = Utils.currencyFormatWithOutdoller(timeArray[0]);;
                } else {
                    afterBlurAmount = Utils.currencyFormatWithOutdoller(e.target.value);
                }
            } else {
                afterBlurAmount = e.target.value === '' ? '' : !isNaN(e.target.value) ? Utils.currencyFormatWithOutdoller(e.target.value) : e.target.value;
            }
        } else {
            afterBlurAmount = "";
        }
        return afterBlurAmount;
    }

    handleFocusAmount = (event: any, rowIndex: any, row: any, type: any) => {
        let { tableData } = this.state;
        let newval = Utils.removecurrencyFormat(event.target.value);
        let validAmount = newval;
        tableData = tableData.map((items) => {
            if (items.rNo === row.rNo && type === "exemptTax") {
                return { ...items, exemptTax: validAmount };
            } else if (items.rNo === row.rNo && type === "exemptRevenue") {
                return { ...items, exemptRevenue: validAmount };
            } else {
                return items;
            }
        });
        this.setState((curr: any) => ({ ...curr, tableData }), () => {
            let inputId = `${type}_${rowIndex}`;
            $("#" + inputId).focus()
            setTimeout(() => { $("#" + inputId).focusout(); }, 10)
        });
    }

    handleBlurAmount = (event: any, rowIndex: any, row: any, type: any) => {
        let { tableData } = this.state;
        let validAmount = this.isValidOnBlurAmount(event)
        tableData = tableData.map((items) => {
            if (items.rNo === row.rNo && type === "exemptTax") {
                return { ...items, exemptTax: validAmount };
            } else if (items.rNo === row.rNo && type === "exemptRevenue") {
                return { ...items, exemptRevenue: validAmount };
            } else {
                return items;
            }
        });
        this.setState((curr: any) => ({ ...curr, tableData }), () => {
            let inputId = `${type}_${rowIndex}`;
            $("#" + inputId).focusout();
        });
    }

    updateExpRow = (row: any) => {
        let { tableData } = this.state;
        tableData = tableData.map((items) => {
            if (items.rNo === row.rNo) {
                if (items.explanation === "") {
                    return { ...items, errExp: true };
                } else if (items.category === "") {
                    return { ...items, errCate: true };
                } else if (items.exemptRevenue === "") {
                    return { ...items, errRev: true };
                } else if (items.exemptTax === "") {
                    return { ...items, errTax: true };
                } else {
                    return {
                        ...items, isEdit: false, errExp: false, errCate: false, errRev: false, errTax: false,
                        exemptRevenue: Utils.removecurrencyFormat(items.exemptRevenue),
                        exemptTax: Utils.removecurrencyFormat(items.exemptTax)
                    };
                }
            } else {
                return items;
            }
        });
        this.setState((curr: any) => ({ ...curr, tableData, }));
    }

    handleEditRow = (row: any) => {
        let { tableData } = this.state;
        let index = tableData.findIndex((x: any) => x.rNo === row.rNo);
        tableData = tableData.map((items) => {
            if (items.rNo === row.rNo) {
                return { ...items, isEdit: true };
            } else {
                return items;
            }
        });
        this.setState((curr: any) => ({ ...curr, tableData, }), () => {
            let eRev = { target: { value: row.exemptRevenue } }
            let eTax = { target: { value: row.exemptTax } }
            setTimeout(() => {
                this.handleFocusAmount(eRev, index, row, "exemptRevenue");
                this.handleFocusAmount(eTax, index, row, "exemptTax");
            }, 10)
            setTimeout(() => {
                this.handleBlurAmount(eRev, index, row, "exemptRevenue");
                this.handleBlurAmount(eTax, index, row, "exemptTax");
            }, 10)
        });
    }

    deleteExpRow = (row: any) => {
        if (row.isEdit) {
            let { tableData } = this.state;
            tableData = tableData.filter((o: any) => { return o.rNo !== row.rNo })
            this.setState({ tableData })
            return
        }
        this.updateExpRow(row);
    }

    addExplanationRow = () => {
        let { tableData } = this.state;
        let newRow = {
            rNo: tableData.length + 1,
            explanation: "",
            category: "",
            exemptRevenue: "",
            exemptTax: "",
            totalRevenue2: "0.00",
            totalActualTax2: "0.00",
            totalRevenueTax2: "0.00",
            exemptRevenue2: "0.00",
            isEdit: true, errExp: false, errCate: false, errRev: false, errTax: false
        };
        tableData = tableData.concat([newRow])
        this.setState({ tableData }, () => {
            setTimeout(() => { this.categoryScroll?.current?.scrollTo({ top: this.categoryScroll?.current?.scrollHeight, behavior: 'smooth' }) }, 50);
        });
    }

    render() {
        const { tableData } = this.state;
        const editIcon = () => {
            return (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.25 11.0959V13.3759C0.25 13.5859 0.415 13.7509 0.625 13.7509H2.905C3.0025 13.7509 3.1 13.7134 3.1675 13.6384L11.3575 5.4559L8.545 2.6434L0.3625 10.8259C0.2875 10.9009 0.25 10.9909 0.25 11.0959ZM13.5325 3.2809C13.825 2.9884 13.825 2.5159 13.5325 2.2234L11.7775 0.468398C11.485 0.175898 11.0125 0.175898 10.72 0.468398L9.3475 1.8409L12.16 4.6534L13.5325 3.2809Z" fill="none" />
                </svg>
            )
        }

        const checkIcon = () => {
            return (
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.59617 7.90605L1.99367 5.30355C1.70117 5.01105 1.22867 5.01105 0.936172 5.30355C0.643672 5.59605 0.643672 6.06855 0.936172 6.36105L4.07117 9.49605C4.36367 9.78856 4.83617 9.78856 5.12867 9.49605L13.0637 1.56105C13.3562 1.26855 13.3562 0.796055 13.0637 0.503555C12.7712 0.211055 12.2987 0.211055 12.0062 0.503555L4.59617 7.90605Z" fill="#2CAF92" />
                </svg>
            )
        }

        const deleteIcon = () => {
            return (
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 4.75V12.25H3V4.75H9ZM7.875 0.25H4.125L3.375 1H0.75V2.5H11.25V1H8.625L7.875 0.25ZM10.5 3.25H1.5V12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V3.25Z" fill="#2CAF92" />
                </svg>
            )
        }

        const columns = [{
            dataField: 'explanation',
            text: 'Explanation/Group',
            classes: (cell, row, rowIndex) => row.isEdit ? "pl-2" : "",
            formatter: (cell, row, rowIndex) => {
                return row.isEdit ? (
                    <Form.Control
                        id={"explanation_" + rowIndex}
                        placeholder="Enter Explanation/Guest"
                        type="text"
                        autoComplete="off"
                        className={`${row.errExp ? "borderError" : ""} editBox w-100 text-left`}
                        value={row.explanation === null || row.explanation === "" ? "" : row.explanation}
                        onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "explanation")}
                        maxLength={50}
                    />
                ) : (
                    <EllipsisWithTooltip placement="bottom">{row.explanation}</EllipsisWithTooltip>
                )
            },
            footerClasses: "taxaudit-footer",
            footer: (columnData, column) => {
                return (
                    <button className="link-button" onClick={this.addExplanationRow}>Add Explanation</button>
                )
            },
        }, {
            dataField: "category",
            text: "Category",
            headerClasses: "width-180",
            formatter: (cell, row, rowIndex) => {
                return row.isEdit ? (
                    <Dropdown className="drop-down-select drop-category" onSelect={(e) => this.handleInputChange(e, rowIndex, row, "category")}>
                        <Dropdown.Toggle id="mapping-rule" className={row.errCate ? "borderError" : ""}>
                            <div className="d-flex align-items-start text-left">
                                <div style={{ width: "90%" }}>
                                    <EllipsisWithTooltip placement="bottom">{row.category === "" ? "Select Category" : row.category}</EllipsisWithTooltip>
                                </div>
                                <div className='arrow ml-auto'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M10 12.8124L5 7.81242L6.16667 6.64575L10 10.4791L13.8333 6.64575L15 7.81242L10 12.8124Z" fill="#1D1E20" />
                                    </svg>
                                </div>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className="scrollableArea">
                                {this.state.categoryList.map(
                                    (item: any, idx: any) => (
                                        <Dropdown.Item eventKey={JSON.stringify(item)} key={item.rNo}>
                                            <EllipsisWithTooltip placement="bottom">{item.value}</EllipsisWithTooltip>
                                        </Dropdown.Item>
                                    )
                                )}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                ) : (
                    <EllipsisWithTooltip placement="bottom">{row.category}</EllipsisWithTooltip >
                )
            },
            footerClasses: "taxaudit-footer",
            footer: '',
        },
        {
            dataField: 'exemptRevenue',
            text: 'Exempt Rev',
            headerClasses: "text-right width-140",
            classes: "text-right",
            formatter: (cell, row, rowIndex) => {
                return row.isEdit ? (
                    <Form.Control
                        id={"exemptRevenue_" + rowIndex}
                        type="text"
                        placeholder="0.00"
                        autoComplete="off"
                        className={`${row.errRev ? "borderError" : ""} editBox w-100 text-right`}
                        value={row.exemptRevenue}
                        onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "exemptRevenue")}
                        onFocus={(e: any) => this.handleFocusAmount(e, rowIndex, row, "exemptRevenue")}
                        onBlur={(e: any) => this.handleBlurAmount(e, rowIndex, row, "exemptRevenue")}
                        maxLength={11}
                    />
                ) : (
                    <EllipsisWithTooltip placement="bottom">{Utils.currencyFormatWithOutdoller(row.exemptRevenue)}</EllipsisWithTooltip>
                )
            },
            footerClasses: "taxaudit-footer",
            footer: '',

        },
        {
            dataField: 'exemptTax',
            text: 'Exempt Tax',
            headerClasses: "text-right width-140",
            classes: "text-right",
            formatter: (cell, row, rowIndex) => {
                return row.isEdit ? (
                    <Form.Control
                        id={"exemptTax_" + rowIndex}
                        type="text"
                        placeholder="0.00"
                        autoComplete="off"
                        className={`${row.errTax ? "borderError" : ""} editBox w-100 text-right`}
                        value={row.exemptTax}
                        onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "exemptTax")}
                        onFocus={(e: any) => this.handleFocusAmount(e, rowIndex, row, "exemptTax")}
                        onBlur={(e: any) => this.handleBlurAmount(e, rowIndex, row, "exemptTax")}
                        maxLength={11}
                    />
                ) : (
                    <EllipsisWithTooltip placement="bottom">{Utils.currencyFormatWithOutdoller(row.exemptTax)}</EllipsisWithTooltip>
                )
            },
            footerClasses: "taxaudit-footer",
            footer: '',
        },
        {
            dataField: '',
            text: '',
            headerClasses: "text-right width-70",
            classes: "exemptTax-Expbutton text-right ",
            formatter: (cell, row, rowIndex) => {
                return row.isEdit ? (
                    <div className="d-flex">
                        <Button onClick={() => this.updateExpRow(row)} className="btn-outline-primary border-0 more">{checkIcon()}</Button>
                        <Button onClick={() => this.deleteExpRow(row)} className="btn-outline-primary border-0 more">{deleteIcon()}</Button>
                    </div>
                ) : (
                    <Button onClick={() => this.handleEditRow(row)} className="btn-outline-primary border-0 more">{editIcon()}</Button>
                )
            },
            footerClasses: "taxaudit-footer",
            footer: '',
        }

        ];
        return (
            <div className="taxaudit-slideout transaction-slideout pos-fxd index-1000">
                <div className="d-flex">
                    <div className="back-drop viewer-panel opacity" onClick={() => this.hideTaxCategoty()}></div>
                    <Container id="SlideBody" fluid className="body-sec viewer-panel">
                        <div className="page-heading pos-sticky underline d-flex">
                            <div className="mr-auto d-flex align-items-center">
                                {this.props?.selectedRow?.explanation}
                            </div>
                            <div className="action-group d-flex">
                                <button type="button" className="btn wht-bg cross" onClick={this.hideTaxCategoty}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z" fill="#84888C" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="parent px-4">
                            <div className="filter-sec py-2 px-4 bg-white">
                                <div className="vendor-type-sec d-flex">
                                    <div className="d-flex flex-wrap mr-auto">
                                        <ul className="d-flex group-boxul">
                                            <li>
                                                <span className="label">Total Revenue Subject to Occ. Tax</span>
                                                <div className="value">{Utils.currencyFormatWithOutdoller(tableData.length > 0 ? tableData[0]?.totalRevenue2 : "0.00")}</div>
                                            </li>
                                            <li>
                                                <span className="label"> Actual Occ. Tax Collected</span>
                                                <div className="value">{Utils.currencyFormatWithOutdoller(tableData.length > 0 ? tableData[0]?.totalActualTax2 : "0.00")}</div>
                                            </li>
                                            <li>
                                                <span className="label">Expected Occ. Tax</span>
                                                <div className="value">{Utils.currencyFormatWithOutdoller(tableData.length > 0 ? tableData[0]?.totalRevenueTax2 : "0.00")}</div>
                                            </li>
                                            <li>
                                                <span className="label">Variance</span>
                                                <div className="value bg-red">{Utils.currencyFormatWithOutdoller(tableData.length > 0 ? tableData[0]?.exemptRevenue2 : "0.00")}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="category-list tabAuditTable">
                            <div className="auditTable-ttl">Explanations</div>
                            <div className="category-scrollableTable" ref={this.categoryScroll}>
                                <BootstrapTable
                                    keyField="rNo"
                                    data={tableData}
                                    columns={columns}
                                // rowEvents={this.rowEvents}
                                />
                            </div>
                        </div>
                    </Container>
                </div>
                {this.state.isDataLoading && (
                    <div className="loader-spinner d-flex justify-content-center align-items-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                )}
            </div>
        );
    }
}